export function initCordova(simpleApi, $rootScope) {
  document.addEventListener("deviceready", function() {
    console.log("Cordova Ready");
    if (
      typeof StatusBar !== "undefined" &&
      document.body.classList.contains("platform-ios")
    ) {
      StatusBar.overlaysWebView(false);
    }

    setupUL();
    setupFCM(simpleApi, $rootScope);
    handleFCMToken(simpleApi, $rootScope);
  });
}

function setupUL() {
  if (!window.universalLinks) {
    console.error("No UL!");
  } else {
    console.log("About to setup UL handlers");
    window.universalLinks.subscribe("authReturn", eventData => {
      const token = eventData.params.access_token;
      if (token) {
        if (token === "LOGOUT") {
          appStorage.removeItem("backend.auth.token");
        } else {
          appStorage.setItem("backend.auth.token", token);
        }
        window.location.reload(true);
      } else {
        console.error("No access_token passed! (nor logout)");
      }
    });
  }
}

function setupFCM(simpleApi, $rootScope) {
  if (window.FCMPlugin) {
    window.FCMPlugin.onNotification(function(data) {
      if (data.wasTapped) {
        // Notification was received on device tray and tapped by the user
        if (data.notificationId) {
          $rootScope.markAsReadAndRefresh(data.notificationId);
        }
        if (data.url) {
          window.location.href = data.url;
        }
      } else {
        // Notification was received in foreground -  update notifications
        $rootScope.fetchNotifications(true);
      }
    });
  } else {
    console.error("FCM NOT set up! Not found");
  }
}

function getRegistrationAPI(simpleApi) {
  return simpleApi({
    name: "registration",
    customMethods: {
      register: {
        endpoint: "/notifications/$/@/registerDevice",
        update: true,
        onUpdate: () => undefined
      },
      remove: {
        endpoint: "/notifications/$/@/removeDeviceToken",
        update: true,
        onUpdate: () => undefined
      }
    }
  });
}

function handleFCMToken(simpleApi, $rootScope) {
  if (!window.FCMPlugin) {
    console.error("FCMPlugin not found!");
    return;
  }

  const api = getRegistrationAPI(simpleApi);

  function handleToken(token) {
    let savedToken = appStorage.getItem("deviceToken");
    if (savedToken && savedToken !== token) {
      api.remove({ token: savedToken }).then(
        () => {},
        error => {
          console.error("ERROR. token not removed. " + error);
        }
      );
    }
    api.register({ token }).then(
      () => {
        console.log("Token registered ok: ", token);
      },
      error => {
        console.error("Error: could not register device token", error);
      }
    );
    appStorage.setItem("deviceToken", token);
  }

  window.FCMPlugin.onTokenRefresh(handleToken);

  function getDeviceToken() {
    window.FCMPlugin.getToken(function(token) {
      // According to docs, may return null if the token has not been created yet
      if (!token || !$rootScope.userdata) {
        console.warn("Cannot yet register", {
          token,
          userdata: $rootScope.userdata
        });
        setTimeout(getDeviceToken, 2000);
        return;
      }
      handleToken(token);
    });
  }

  getDeviceToken();
}

function versionIsGreaterOrEqual(a, b) {
  const va = a.split(".");
  const vb = b.split(".");
  for (let i = 0; i < 3; i++) {
    if (va[i] > vb[i]) return true;
    if (va[i] < vb[i]) return false;
  }
  return true;
}

export function checkMobileAppVersion(config) {
  if (!window.cordova) return;
  const prefix = window.device.platform === "iOS" ? "iOS" : "android";
  const min = config[prefix + "AppMinAcceptableVersion"];
  const latest = config[prefix + "AppLatestVersion"];
  const link = config[prefix + "InstallLink"];
  const current = MOBILE_VERSION;
  let send = false;

  const mobileUpdate = { min, latest, current, link };
  console.warn(MOBILE_VERSION, mobileUpdate);
  if (min && !versionIsGreaterOrEqual(MOBILE_VERSION, min)) {
    // Mandatory update
    mobileUpdate.mandatory = true;
    send = true;
  } else if (latest && !versionIsGreaterOrEqual(MOBILE_VERSION, latest)) {
    // Optional update
    if (localStorage.getItem("ignoreMobileUpdate")) {
      // Ignore situation and clear flag
      localStorage.removeItem("ignoreMobileUpdate");
    } else {
      send = true;
    }
  }

  if (send) {
    localStorage.setItem("mobileUpdate", JSON.stringify(mobileUpdate));
    window.location.href = "mobile_update.html";
    throw new Error("No actual error - just stopping execution");
  }
}



// WEBPACK FOOTER //
// ./src/utils/cordovaUtils.js